import * as uuid from 'uuid';

export function mapWithClientID(entity) {
    return {
        ...entity,
        id: uuid(),
        backendId: entity.id
    }
}


// WEBPACK FOOTER //
// ./src/common/utils/objects.js